import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import '../resultsCapture/styleSidebar.css'

export const SidebarClinicalInfo = (props) => {
    const {
        uniqueQuestions, tableRows, visibleTop, setVisibleTop

    } = props;





    return (
        <>
            <Sidebar
                className="sidebarCustom"
                visible={visibleTop}
                position="top"
                onHide={() => setVisibleTop(false)}
                style={{
                    height: 'auto',
                    maxHeight: '45vh',
                    overflowY: 'auto',
                    padding: '0.25rem',
                    borderRadius: '0 0 10px 10px',
                }}
            >

                <label className=' f-w-600 f-14' style={{ color: "#f97316", display: 'block', textAlign: 'center', width: '100%', marginBottom: '0.5rem' }}>
                    INFORMACIÓN CLÍNICA
                </label>

                <div className='table-responsive' style={{ fontSize: '10px' }}>
                    {uniqueQuestions.length === 0 ? (
                        <>
                            <hr />
                            <div style={{ textAlign: 'center', padding: '1rem' }}>
                                <i className='icofont icofont-doctor-alt txt-danger f-32'></i>
                                <div>
                                    <label className='f-w-600 txt-danger f-14'>No se ha realizado el proceso de toma</label>
                                </div>
                            </div>
                        </>
                    ) : (
                        <table className="table table-bordered table-striped" style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>
                                <tr style={{ backgroundColor: '#1d5b83' }}>
                                    <th
                                        rowSpan="2"
                                        style={{
                                            verticalAlign: 'middle',
                                            fontWeight: 'bold',
                                            textAlign: 'center',
                                            color: '#ffffffff',
                                        }}
                                    >
                                        Nombre del Examen
                                    </th>
                                    {uniqueQuestions.map((preg, i) => {
                                        const isComentario = preg.toLowerCase().includes("comentario") || preg.toLowerCase().includes("flebotomista");
                                        return !isComentario ? (
                                            <th
                                                key={i}
                                                style={{
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    color: '#ffffffff',
                                                }}
                                            >
                                                {preg}
                                            </th>
                                        ) : null;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tableRows.map((fila, index) => {
                                    if (fila.type === 'Answers') {

                                        const firstExamIndex =
                                            tableRows.findIndex(
                                                r => r.exam === fila.exam
                                            );

                                        const isFirst =
                                            firstExamIndex === index;
                                        return (
                                            <tr key={index}>
                                                {isFirst && (
                                                    <td 
                                                    rowSpan={
                                                        tableRows.filter(
                                                            r => r.exam === fila.exam
                                                        ).length
                                                    }>
                                                        <strong>{fila.exam}</strong>
                                                    </td>
                                                )}
                                                {uniqueQuestions.map((preg, i) => {
                                                    const isComentario = preg.toLowerCase().includes("comentario") || preg.toLowerCase().includes("flebotomista");
                                                    return !isComentario ? (
                                                        <td key={i} style={{ textAlign: 'center' }}>
                                                            {fila[preg.toLowerCase()] || ""}
                                                        </td>
                                                    ) : null;
                                                })}
                                            </tr>
                                        );
                                    }

                                    if (fila.type === 'Toma') {
                                        const totalCols = uniqueQuestions.filter(p => {
                                            const isComentario = p.toLowerCase().includes("comentario") || p.toLowerCase().includes("flebotomista");
                                            return !isComentario;
                                        }).length + 1;

                                        const colSpanToma = Math.max(1, Math.floor(totalCols * 0.1));
                                        const colSpanComentario = fila.isGeneral
                                            ? Math.floor(totalCols * 0.7)
                                            : Math.floor(totalCols * 0.6);

                                        const colSpanFlebotomista = fila.isGeneral
                                            ? totalCols - colSpanComentario
                                            : totalCols - colSpanToma - colSpanComentario;
                                        const rowColor1 = '#f5fcffd0';
                                        const rowColor2 = '#ffffffff';

                                        const backgroundColor = index % 2 === 0 ? rowColor1 : rowColor2;

                                        return (
                                            <tr key={index} style={{ backgroundColor }}>
                                                {!fila.isGeneral && (
                                                    <td
                                                        colSpan={colSpanToma}
                                                        style={{
                                                            fontWeight: 'bold',
                                                            textAlign: 'center'
                                                        }}
                                                    >
                                                        TOMA {
                                                            tableRows.filter(
                                                                r =>
                                                                    r.type === 'Toma' &&
                                                                    r.exam === fila.exam &&
                                                                    !r.isGeneral
                                                            ).indexOf(fila) + 1
                                                        }
                                                    </td>
                                                )}

                                                <td colSpan={colSpanComentario}>
                                                    <strong>COMENTARIO:</strong> {fila.comentario}
                                                </td>
                                                <td colSpan={colSpanFlebotomista}>
                                                    <strong>FLEBOTOMISTA:</strong> {fila.flebotomista}
                                                </td>
                                            </tr>
                                        );
                                    }

                                    return null;
                                })}

                            </tbody>

                        </table>
                    )}

                </div>

            </Sidebar>

        </>
    );
};
